import RichTextDisplay from './RichTextDisplay';

export default RichTextDisplay;
